(ns hai.web-app.components
  "General HumbleAI web app (the concept) components"
  (:require
   [hai.ui.components :as c]
   [hai.ui.components.spinners :as spinners]
   [hai.ui.components.page-not-found :as page-not-found]
   [hai.ui.icons :as icons]
   [lambdaisland.ornament :as o]
   [hai.ui.tokens :as t]
   [hai.web-app.routing :as routing]))

(defn- sign-in-redirect-path
  "Where sign-in lands back: this page, keeping the query params routing
   forwards (e.g. `version`), so a pinned frontend survives the OAuth round
   trip. Encoded, since it rides inside the login URL's own query string."
  []
  (js/encodeURIComponent
   (routing/path-with-forwarded-query-params js/window.location.pathname)))

(comment
  ;; necessary import to trigger clj compilation
  page-not-found/full-page
  )

(defn full-center [body]
  [c/Flex {:direction "column" :justify "center" :height "100vh"}
   [c/Flex {:direction "row" :justify "center"}
    body]])

(o/defstyled humble-brand :div
  :font-bold :flex :items-center :text-5xl :gap-2
  :tracking-tighter
  {:color t/--humble-primary-dark}
  [:img {:width "64px" :height "64px" :border-radius "12px"}]
  ([]
   [:<>
    [:img {:src "/imgs/humble-avatar-blink.gif"
           :alt "Humble AI"}]
    "Humble"]))

(o/defstyled humble-loader :div
  ([]
   [:<>
    [humble-brand]
    [spinners/pulse-dots]]))

(o/defstyled sign-in-options :div
  {:background-color t/--humble-offwhite}
  {:color t/--humble-primary-dark}
  :min-w-156
  :px-28.5 :py-16 :rounded-3xl
  [:.header :flex :flex-col :gap-2 :text-center
   [:.hello :text-md :center :font-medium :pl-4]]
  [:a.sign-in-btn :flex :items-center :justify-center :gap-2 :font-medium :font-size-16px :w-full :text-center
   :bg-white
   :hover:bg-gray-100 :shadow-lg
   :py-2 :px-4 :rounded-lg
   [:svg :w-32px]
   ["&:hover" {:background-color c/--gray-12
               :color c/--color-background}]]

  [:.divider :flex :items-center :gap-4 :w-full
   [:>.line :flex-grow :border-t :border-1 :border-gray-300]
   [:>.or :text-sm :text-gray-500]]

  [:.continue-btn :w-32 :mx-auto :rounded-full :px-24 :py-6
   {:background-color t/--humble-primary-dark}]
  ([req opts]
   [c/Flex {:direction "column" :gap "8" :align "center"}
    [:div.header
     [:p.hello "Say hello to"]
     [humble-brand]]

    [c/Flex {:direction "column" :gap "4" :width "100%"}
     [:a.sign-in-btn
      {:href (str "/login/google?redirect-path=" (sign-in-redirect-path) "&response_type=none")
       :target "_top"}
      [icons/google]
      "Sign in with Google"]
     [:a.sign-in-btn
      {:href (str "/login/microsoft?redirect-path=" (sign-in-redirect-path) "&response_type=none")
       :target "_top"}
      [icons/microsoft]
      "Sign in with Microsoft"]]

    [:div.divider
     [:div.line]
     [:span.or "or"]
     [:div.line]]

    [c/Flex {:direction "column" :gap "1" :width "100%"}
     [:label {:for "email"} "Enter email"]
     [c/TextFieldRoot {:id "email" :placeholder "your.email@example.com"}]
     ]

    [c/Flex {:direction "column" :gap "4" :width "100%" :align "center"}
     [c/Button {:class "continue-btn"
                :on-click (fn []
                            (set! js/document.location
                                  (str "/login/otp?email=" (.-value (js/document.querySelector "#email"))
                                       "&redirect-path=" (sign-in-redirect-path))))}
      "Continue"]
     [c/Text {:size "1" :color "gray"} "By continuing, you agree to our "
      [c/Link {:href "https://www.humbleai.com/privacy-policy"
               :target "_blank"} "Privacy Policy."]]]]))

(o/defstyled sign-in-skeleton sign-in-options
  {:min-height "20rem"
   :min-width "15rem"}
  ([req opts]
   [c/Flex {:direction "column" :gap "4"}
    [:div.humble
     [:img {:src "/imgs/humble-avatar-blink.gif"
            :alt "Humble AI"
            :width "32"
            :height "32"
            :style {:border-radius "8px"}}]
     "Humble."]

    [:div [c/Skeleton "Sign in with Google......"]]
    [:div [c/Skeleton "Sign in with Google......"]]
    [:div [c/Skeleton "Sign in with Microsoft......"]]
    [:div [c/Skeleton "Sign in with Microsoft......"]]

    [:div.divider
     [:div.line]
     [:span.or [c/Skeleton "or"]]
     [:div.line]]

    [c/Flex {:direction "column" :gap "1"}
     [:div [c/Skeleton "Email..."]]
     [:div [c/Skeleton "Sign in....."]]]]))

(o/defstyled welcome-quote :div
  :max-w-60%
  {:color t/--humble-secondary}
  :text-6xl
  [:.top-quote]
  [:.box-quote :px-24 :py-12
   {:background-color t/--humble-secondary
    :color t/--humble-primary-dark}]
  ([]
   [:<>
    [:p.top-quote "To scale and win deals with proposals that are faster, better and more consistent"]
    [:p.box-quote "Humble has streamlined our entire product automation in a seamless way."]]))

(o/defstyled sign-in-page :div
  :flex :justify-center :h-100vh :items-center
  [:>div :xl:w-50%]
  [:.left :flex :items-center :justify-center]
  [:.right :hidden :xl:flex]
  {:background t/--humble-primary-dark}
  ([]
   [:<>
    [:div.left
     [sign-in-options]]

    ;; to be implemented later to match the figma designs, for now we
    ;; only have the above sign-in-options
    #_[:div.right
       [welcome-quote]]]))
